import e from "./Highlighter-vue2.vue_rollup-plugin-vue=script.js";
export default (function (e, t, i, n, r, s, l, u) {
  var o = ("function" == typeof i ? i.options : i) || {};
  return o.__file = "Highlighter-vue2.vue", o.render || (o.render = e.render, o.staticRenderFns = e.staticRenderFns, o._compiled = !0, r && (o.functional = !0)), o._scopeId = n, o;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        i = e._self._c || t;
    return i("span", {
      class: e.suit()
    }, e._l(e.parsedHighlights, function (t, n) {
      var r = t.value,
          s = t.isHighlighted;
      return i(s ? e.highlightedTagName : e.TextNode, {
        key: n,
        tag: "component",
        class: [s && e.suit("highlighted")]
      }, [e._v(e._s(r))]);
    }), 1);
  },
  staticRenderFns: []
}, 0, e, void 0, !1);